import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { useCheckoutStore } from './checkout-store';

interface UIState {
  activeStep: 'tickets' | 'hotel' | 'flights';
  cartId: number | undefined;
  setCartId: (cartId: number | undefined) => void;
  cartUuid: string | undefined;
  setCartUuid: (cartUuid: string | undefined) => void;
  ticketSelected: boolean;
  hotelSelected: boolean;
  flightsSelected: boolean;
  clearAllState: () => void;
}

export const useCheckoutStepsStore = create(
  persist<UIState>(
    (set) => ({
      cartId: undefined,
      setCartId: (cartId) => {
        useCheckoutStore.getState().activateRefundableCart(cartId);
        set({ cartId });
      },
      cartUuid: undefined,
      setCartUuid: (cartUuid) => set({ cartUuid }),
      activeStep: 'tickets',
      ticketSelected: false,
      hotelSelected: false,
      flightsSelected: false,
      clearAllState: () => {
        set({
          activeStep: 'tickets',
          ticketSelected: false,
          hotelSelected: false,
          flightsSelected: false,
        });
      },
    }),
    {
      name: 'stps',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' &&
        typeof localStorage.getItem === 'function'
          ? localStorage
          : (null as any)
      ),
      onRehydrateStorage: () => (state) => {
        if (typeof state?.cartId === 'number') {
          useCheckoutStore.getState().activateRefundableCart(state.cartId);
        }
      },
    }
  )
);
